function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class SectionVideo extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));

    window.addEventListener("DOMContentLoaded", () => {
      //Ajouter le poster à la première image du produit
      this.addPosterToFirstProductImage();
    });
  }

  addPosterToFirstProductImage() {
    //Récupérer l'url du poster
    const posterUrl = this.querySelector("#url-poster").getAttribute("data-url");

    console.log("Récupération de l'url du poster", posterUrl);

    //Chercher la première image du produit
    const productImages = document.querySelectorAll(".product-image-1");

    //Créer une div avec l'image sur l'image du produit
    const posterDiv = document.createElement("a");
    posterDiv.href = "#" + this.id;
    posterDiv.style.width = "110px";
    posterDiv.style.height = "110px";
    posterDiv.style.position = "absolute";
    posterDiv.style.bottom = "70px";
    posterDiv.style.left = "30px";
    posterDiv.style.borderRadius = "100%";
    posterDiv.style.zIndex = "30";

    const posterImage = document.createElement("img");
    posterImage.src = posterUrl;
    posterImage.style.width = "110px";
    posterImage.style.height = "110px";
    posterImage.style.borderRadius = "100%";
    posterDiv.appendChild(posterImage);

    productImages.forEach((image) => {
      image.appendChild(posterDiv.cloneNode(true));
    });
  }

  loadContent(focus = true) {
    //window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("section-video", SectionVideo);
